import React from 'react';

import Header from '../../layout/Header.jsx';
import ListItems from '../../lists/ListItems.jsx';

const PageItemsList = () => (
  <div>
    <Header>Items</Header>
    <ListItems />
  </div>
);

export default PageItemsList;
